var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDrapeauEn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9858 17.1902H2.26942C2.05133 17.1902 1.875 17.0107 1.875 16.7887V2.58509C1.875 2.36309 2.05133 2.18359 2.26942 2.18359H23.9905C24.2086 2.18359 24.3849 2.36309 24.3849 2.58509V16.7934C24.3802 17.0107 24.2039 17.1902 23.9858 17.1902Z",
    fill: "#41479B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.02246 0.0996094H1.02734C1.54354 0.0996094 1.95996 0.517003 1.95996 1.0332V23.9668C1.95996 24.4833 1.54345 24.9003 1.0332 24.9004C0.517003 24.9004 0.0996094 24.483 0.0996094 23.9668V1.02246C0.0996094 0.5169 0.512105 0.0996094 1.02246 0.0996094Z",
    fill: "#4E5462",
    stroke: "#3B3C3D",
    strokeWidth: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3849 2.57552C24.3849 2.35831 24.2131 2.18359 23.9996 2.18359H22.2634L15.0727 6.97645V2.18359H11.1918V6.97645L3.99647 2.18359H2.2603C2.04676 2.18359 1.875 2.35831 1.875 2.57552V3.59548L8.04445 7.70836H1.875V11.656H8.04445L1.875 15.7689V16.7888C1.875 17.006 2.04676 17.1807 2.2603 17.1807H3.99647L11.1872 12.3879V17.1807H15.0681V12.3973L22.2588 17.1902H23.9949C24.2085 17.1902 24.3802 17.0155 24.3802 16.7983V15.7783L18.2108 11.6654H24.3849V7.71781H18.2154L24.3849 3.6002V2.57552Z",
    fill: "#F5F5F5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.38 8.50325H14.2901V2.18359H11.9649V8.50325H1.875V10.8743H11.9649V17.1892H14.2901V10.8743H24.38V8.50325Z",
    fill: "#FF4B55"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.74347 11.6629L1.89062 16.849C1.91847 17.0379 2.07163 17.1891 2.2712 17.1891H2.80493L11.1729 11.6582H9.74347V11.6629Z",
    fill: "#FF4B55"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1045 11.6621H15.6797L24.0338 17.1835C24.2287 17.1647 24.3819 16.9993 24.3819 16.7962V16.4703L17.1045 11.6621Z",
    fill: "#FF4B55"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.87964 3.0142L8.9899 7.7138H10.4147L2.10242 2.2207C1.96782 2.2821 1.875 2.41908 1.875 2.57967C1.87964 2.57967 1.87964 3.0142 1.87964 3.0142Z",
    fill: "#FF4B55"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4983 7.71448L24.3744 2.5095C24.3419 2.32529 24.1887 2.18359 23.9984 2.18359H23.4415L15.0781 7.71448H16.4983Z",
    fill: "#FF4B55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrapeauEn);
export default __webpack_public_path__ + "static/media/drapeau_EN.da8af7d963291fd82d1334c620cb952f.svg";
export { ForwardRef as ReactComponent };